/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AuthedHistoryRouteImport } from './routes/_authed.history'
import { Route as AuthedHomeRouteImport } from './routes/_authed.home'
import { Route as AuthedVehiclesRouteImport } from './routes/_authed.vehicles'
import { Route as TrackTokenRouteImport } from './routes/track.$token'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedHistoryRoute = AuthedHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHomeRoute = AuthedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedVehiclesRoute = AuthedVehiclesRouteImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => AuthedRoute,
} as any)
const TrackTokenRoute = TrackTokenRouteImport.update({
  id: '/track/$token',
  path: '/track/$token',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/history': typeof AuthedHistoryRoute
  '/home': typeof AuthedHomeRoute
  '/vehicles': typeof AuthedVehiclesRoute
  '/track/$token': typeof TrackTokenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/history': typeof AuthedHistoryRoute
  '/home': typeof AuthedHomeRoute
  '/vehicles': typeof AuthedVehiclesRoute
  '/track/$token': typeof TrackTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authed/history': typeof AuthedHistoryRoute
  '/_authed/home': typeof AuthedHomeRoute
  '/_authed/vehicles': typeof AuthedVehiclesRoute
  '/track/$token': typeof TrackTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/history'
    | '/home'
    | '/vehicles'
    | '/track/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/history'
    | '/home'
    | '/vehicles'
    | '/track/$token'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/login'
    | '/register'
    | '/_authed/history'
    | '/_authed/home'
    | '/_authed/vehicles'
    | '/track/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  TrackTokenRoute: typeof TrackTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/history': {
      id: '/_authed/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AuthedHistoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/home': {
      id: '/_authed/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthedHomeRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/vehicles': {
      id: '/_authed/vehicles'
      path: '/vehicles'
      fullPath: '/vehicles'
      preLoaderRoute: typeof AuthedVehiclesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/track/$token': {
      id: '/track/$token'
      path: '/track/$token'
      fullPath: '/track/$token'
      preLoaderRoute: typeof TrackTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AuthedRouteChildren {
  AuthedHistoryRoute: typeof AuthedHistoryRoute
  AuthedHomeRoute: typeof AuthedHomeRoute
  AuthedVehiclesRoute: typeof AuthedVehiclesRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedHistoryRoute: AuthedHistoryRoute,
  AuthedHomeRoute: AuthedHomeRoute,
  AuthedVehiclesRoute: AuthedVehiclesRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  TrackTokenRoute: TrackTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
